import axios from 'axios';

export const $getNotice = () => {
  return axios.get(`/api/notice`)
}

export const $toggleAlarm = (empNo) => {
  return axios.put(`/api/alarm?empNo=${empNo}`)
}

export const $getAlarmFlag = (empNo) => {
  return axios.get(`/api/alarm?empNo=${empNo}`)
}




// WEBPACK FOOTER //
// ./src/_api_/noticeAPI.js